{
  "en": {
    "answers": [
      {
        "id": 1328484,
        "text": "⭐⭐⭐⭐⭐",
        "is_right": true
      },
      {
        "id": 1328485,
        "text": "⭐⭐⭐⭐",
        "is_right": false
      },
      {
        "id": 1328486,
        "text": "⭐⭐⭐",
        "is_right": false
      },
      {
        "id": 1328487,
        "text": "⭐⭐",
        "is_right": false
      },
      {
        "id": 1328488,
        "text": "⭐",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 156068,
        "name": "Sample Question"
      },
      {
        "id": 156083,
        "name": "Survey Question"
      },
      {
        "id": 156084,
        "name": "Scale"
      }
    ],
    "text": "How satisfied are you with the course?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 2,
    "created_at": "2025-09-02T15:04:01.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:55:46.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "### Please select a value on the scale:\n\n* ⭐⭐⭐⭐⭐ = highest satisfaction (5 stars)\n* ⭐⭐⭐⭐ = very satisfied (4 stars)\n* ⭐⭐⭐ = satisfied (3 stars)\n* ⭐⭐ = rather dissatisfied (2 stars)\n* ⭐ = lowest satisfaction (1 star)\n\nPlease choose a value on the scale from **5 stars for the highest rating** to **1 star for the lowest rating**.",
    "has_explanation": true,
    "num_answers": 5
  },
  "de": {
    "answers": [
      {
        "id": 1329036,
        "text": "⭐⭐⭐⭐⭐",
        "is_right": true
      },
      {
        "id": 1329037,
        "text": "⭐⭐⭐⭐",
        "is_right": false
      },
      {
        "id": 1329038,
        "text": "⭐⭐⭐",
        "is_right": false
      },
      {
        "id": 1329039,
        "text": "⭐⭐",
        "is_right": false
      },
      {
        "id": 1329040,
        "text": "⭐",
        "is_right": false
      }
    ],
    "tags": [
      {
        "id": 9427,
        "name": "Musterfrage"
      },
      {
        "id": 14279,
        "name": "Umfragen/Evaluationen"
      }
    ],
    "text": "Wie zufrieden bist Du mit dem Kurs?",
    "display_in_order": true,
    "is_poll_question": true,
    "type": 2,
    "created_at": "2025-09-03T08:00:33.000Z",
    "created_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "updated_at": "2025-09-03T08:25:47.000Z",
    "updated_by": "407c2236-d02c-4f64-abb4-bf31cda99416",
    "explanation": "### Bitte wähle einen Wert auf der Skala:\n\n* ⭐⭐⭐⭐⭐ = höchste Zufriedenheit (5 Sterne)\n* ⭐⭐⭐⭐ = sehr zufrieden (4 Sterne)\n* ⭐⭐⭐ = zufrieden (3 Sterne)\n* ⭐⭐ = eher unzufrieden (2 Sterne)\n* ⭐ = niedrigste Zufriedenheit (1 Stern)\n\nBitte wähle einen Wert auf der Skala von 5 Sternen für den höchsten Wert bis 1 Stern für den niedrigsten Wert.",
    "has_explanation": true,
    "num_answers": 5
  }
}
